// a mini defer like angular's $q.defer()
// Used for the ACTIONSHEET.vue component

export default function() {
  var promise;
  var resolve;
  var reject;

  /* eslint-disable-next-line promise/param-names */
  promise = new Promise(function(_resolve_, _reject_) {
    resolve = _resolve_;
    reject = _reject_;
  });

  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
}



// WEBPACK FOOTER //
// ./src/components/from_st_elsewhere/defer.js